import { Flex } from '@chakra-ui/react';
import { Grid, TextExt } from '@time-line/components/common';

type HeroProps = {
  heading?: string;
};

export const Hero = ({ heading }: HeroProps) => (
  <Grid.Inner mb={{ base: 'sm', lg: 'lg' }} gridRowGap="sm">
    <Flex
      className="footer_intro"
      gridColumn="span 12"
      alignItems="center"
      justifyContent="center"
      h={{ lg: '30vh' }}
      minH={{ lg: '240px' }}
      maxH={{ lg: '360px' }}
      py={{ base: 'm', lg: 0 }}
    >
      <TextExt as="h2" size="h2" textAlign="center" sx={{ textWrap: 'pretty' }}>
        {heading}
      </TextExt>
    </Flex>
  </Grid.Inner>
);
